module.exports = __webpack_public_path__ + "img/csr2.12198ecc.jpg";